import React, { useState } from 'react';
import walkInJobs from './WalkInJobs';
import { Card, Container, Row, Col, Form } from 'react-bootstrap';
 
const WalkInJobSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
 
  // Filter jobs based on the search term
  const filteredJobs = walkInJobs.filter((job) =>
    job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.experience.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.description.toLowerCase().includes(searchTerm.toLowerCase())
  );
 
  return (
    <Container>
      <h2 className="my-4 text-center">Walk in Job Openings</h2>
 
      {/* 🔍 Search Bar */}
      <Form className="mb-4">
        <Form.Control
          type="text"
          placeholder="Search by title, location, experience, or description..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Form>
 
      <Row>
   
        {filteredJobs.length > 0 ? (
          filteredJobs.map((job) => (
            <Col key={job.id} sm={12} md={6} lg={4} className="mb-4">
              <Card>
                <Card.Body>
                  <Card.Title>{job.title}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">Location: {job.location}</Card.Subtitle>
                  <Card.Text><strong>Experience:</strong> {job.experience}</Card.Text>
                  <Card.Text><strong>Description:</strong> {job.description}</Card.Text>
                  <Card.Text className="text-muted">{job.date}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <p className="text-center">No jobs found matching your search.</p>
        )}
      </Row>
    </Container>
  );
};
 
export default WalkInJobSearch;
 
 